import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { bestSellingProducts } from '../services/Product-service';

function BestSellingDesigns({ showbestselling, sectionTitle }) {
    const [products, setProducts] = useState([]);

    useEffect(() => {
        if (!showbestselling) return;

        bestSellingProducts()
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                setProducts(
                    list.filter(
                        (product) =>
                            product?.id &&
                            (product.cover_image ||
                                product.large_image ||
                                product.product_thumbail)
                    )
                );
            })
            .catch((error) => {
                console.error('Error fetching best selling designs:', error);
            });
    }, [showbestselling]);

    const layout = useMemo(() => {
        if (products.length < 2) return null;

        const imageFor = (product, preferWide = false) =>
            (preferWide
                ? product.cover_image || product.large_image || product.product_thumbail
                : product.product_thumbail || product.cover_image || product.large_image);

        const mapItem = (product, preferWide = false) => {
            const designer = (product.designer_name || '').trim();
            const title = (product.product_title || '').trim();
            const collection = (
                product.collection_name ||
                product.collection ||
                product.campaign_name ||
                ''
            ).trim();

            return {
                id: product.id,
                src: imageFor(product, preferWide),
                alt: title || designer || 'Best selling design',
                link: `/products/productdetails/${product.id}`,
                name: designer || title,
                subtitle: collection || (designer && title && title !== designer ? title : ''),
            };
        };

        const banner = products[0];
        const side = products[1];
        const bottom = products.slice(2, 5);

        return {
            banner: mapItem(banner, true),
            side: mapItem(side, false),
            bottom: bottom.map((product) => mapItem(product, false)),
        };
    }, [products]);

    const renderOverlay = (item) => (
        <span className="best-selling-overlay">
            {item.name ? (
                <span className="best-selling-overlay-name">{item.name}</span>
            ) : null}
            {item.subtitle ? (
                <span className="best-selling-overlay-subtitle">{item.subtitle}</span>
            ) : null}
            <span className="best-selling-overlay-cta">SHOP NOW</span>
        </span>
    );

    if (!showbestselling || !layout) return null;

    return (
        <div className="App">
            <div className="BreakPointContainer">
                <div className="CarouselSectionContainer best-selling-designs">
                    <div className="SectionTitle">
                        <h1 className="m-t-0 m-b-15 text-left demi-bold">{sectionTitle || 'BEST SELLING DESIGNS'}</h1>
                    </div>
                    <div className="best-selling-designs-grid">
                        <Link to={layout.banner.link} className="best-selling-banner">
                            <img src={layout.banner.src} alt={layout.banner.alt} />
                            {renderOverlay(layout.banner)}
                        </Link>
                        <Link
                            to={layout.side.link}
                            className="best-selling-card best-selling-card-side"
                        >
                            <img src={layout.side.src} alt={layout.side.alt} />
                            {renderOverlay(layout.side)}
                        </Link>
                        {layout.bottom.map((item) => (
                            <Link
                                to={item.link}
                                className="best-selling-card"
                                key={item.id}
                            >
                                <img src={item.src} alt={item.alt} />
                                {renderOverlay(item)}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BestSellingDesigns;
